import * as React from 'react';

import { themedFonts, useCurrentTheme } from '../theme';
import { PlainMarkdownContext } from './PlainMarkdownProvider';

/**
 * An utility hook to decide how the nodes should be styled
 */
export function usePlainMarkdownStyle() {
    const [, font] = useCurrentTheme(themedFonts);
    const plainMarkdownCtx = React.useContext(PlainMarkdownContext);

    return React.useMemo(() => {
        return {
            textStyle: plainMarkdownCtx?.kind === 'secondary' ? font.textMuted : font.text,
        };
    }, [plainMarkdownCtx, font]);
}
